import React, { Component } from 'react'

import ProjectCard from './ProjectCard'

import { projects } from './projectlist'
// import { Link } from 'gatsby'

const getFilters = (projects) =>
{
    let allFilters = []
    projects.forEach(project =>
    {
        allFilters = allFilters.concat(project.filters)
    })
    const uniqueSet = new Set(allFilters)
    return [...uniqueSet]
}

const uniqueFilters = getFilters(projects)

export default class Projects extends Component
{

    // Seeded with the full list rather than filled in componentDidMount: that hook never
    // runs during SSR, so starting empty meant the built HTML shipped zero project
    // titles, blurbs, tags or outbound links -- nothing for a crawler that does not run
    // JS, and no plain-text fallback if the bundle ever failed to hydrate.
    state = {
        projects: projects,
        filter: null
    }

    filterArray = (filter) =>
    {
        let newArray = projects.filter(element =>
        {
            let match = false
            element.filters.forEach(elementfilter =>
            {
                if (elementfilter === filter)
                    match = true
            })
            return match
        })
        this.setState({
            projects: newArray,
            filter: filter
        })
    }

    resetArray = () =>
    {
        this.setState({
            projects: projects,
            filter: null
        })
    }

    render()
    {
        return (
            <React.Fragment>

                <div className="flex flex-wrap font-mono text-sm md:text-lg justify-center">
                    {/* <span className="text-center">Filter</span> */}
                    <button className={`link-pink${this.state.filter === null ? ' link-pink-active' : ''}`} onClick={() => { this.resetArray() }}>All</button>
                    {uniqueFilters.map((filter, index) => (
                        <button key={index} className={`link-pink mx-1${this.state.filter === filter ? ' link-pink-active' : ''}`} onClick={() =>
                        {
                            this.filterArray(filter.toLowerCase())
                        }}>{filter.toLowerCase()}</button>
                    ))}
                </div>
                <div className="flex flex-wrap justify-center">

                    {this.state.projects.map((project, index) => (
                        <ProjectCard key={index} project={project} randomRotation={this.props.randomRotation} />
                    ))}


                </div>


            </React.Fragment>

        )
    }
}